import { Box, Stack } from "@mui/material";
import parlors from "goi_common/src/constants/parlors_detail.json";

import {
  ParlorRegionHeadSection,
  BTypeCardView,
  DTypeBreadCrumb,
  BTypeRegionHead,
  CTypeParlorList,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  ParlorDetailProps,
  numberToLocalString,
  colors,
  buildParlorRegionPageSchema,
  ParlorRegionFAQ,
  RichSearch,
} from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { GetStaticPaths, GetStaticProps } from "next";
import Head from "next/head";

// Path 로직 안내
// FUNERAL_SIDO, SIGUNGU의 key로 path 설정.
//
// 1. getStaticPaths 내 key,value 받아서 value(key)로 추가한 뒤 params로 넘기게 변경
// 2. getStaticProps 내 props sido,sigungu, sidoName, sigunguName에 split,replace 로직 추가

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const sidoList = Array.from(FUNERAL_SIDO).filter(([key, val]) =>
    targetSidos.includes(String(key))
  );

  const sidoPath = sidoList.map(([key, val]) => {
    return {
      params: {
        code: `${val}(${key})`,
      },
    };
  });

  const sigunguPaths = Array.from(FUNERAL_SIDO)
    .filter(([key, val]) => targetSidos.includes(String(key)))
    .map(([sidoKey, sidoVal]) => {
      const sigungus = FUNERAL_SIGUNGU.get(sidoKey);
      if (sigungus) {
        return Array.from(sigungus).map(([sigunguKey, sigunguVal]) => {
          return {
            params: {
              code: `${sidoVal}(${sidoKey})-${sigunguVal}(${sigunguKey})`,
            },
          };
        });
      }
    })
    .filter((i) => i != null);

  return {
    paths: sidoPath.concat(sigunguPaths?.flat() as Array<any>),
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const code = params?.code as string;

  if (code.includes("-")) {
    const [sido, sigungu] = code.split("-");
    const sidoName = sido.split("(")[0];
    const sigunguName = sigungu.split("(")[0];
    const sidoNumber = sido.split("(")[1].replace(")", "");
    const sigunguNumber = sigungu.split("(")[1].replace(")", "");

    const regionParlors = parlors.filter(
      (p) => String(p.sigungu) === String(sigunguNumber)
    );

    const 가족장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["가족장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 무빈소장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["무빈소"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 일반장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["일반장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();

    let parlorsString = "";
    regionParlors.map((p: any) => {
      parlorsString += `${p.companyname} ${numberToLocalString(
        p.binsos[0].charge
      )}원, `;
    });

    const description = `${sidoName} ${sigunguName} 내 ${regionParlors.length}곳의 장례식장을 대상으로 한 비용 비교: 1일 동안 100명의 조문객이 참석할 때의 빈소 비용 및 추가 비용에 대한 정보 부산, 울산, 경남, 경상 및 주변 지역 장례식장 추천도 함께 포함 | ${parlorsString}...`;

    return {
      props: {
        regionParlors,
        expectedParlorPrice: { 무빈소장, 가족장, 일반장 },
        sidoName,
        sido: sidoNumber,
        sigunguName,
        sigungu: sigunguNumber,
        isSigungu: true,
        pageDescription: description,
        pageKeywords: `${sidoName} ${sigunguName} 장례식장, ${sidoName} ${sigunguName} 장례식장 추천, ${sidoName} ${sigunguName} 장례식장 비용, ${sidoName} ${sigunguName} 장례식장 평균 예상 비용, ${sidoName} ${sigunguName}  무빈소, ${sidoName} ${sigunguName}  가족장, ${sidoName} ${sigunguName} `,
        pageOgTitle: `${sidoName} ${sigunguName} 지역 장례식장 추천, 비교 :: 부산울산경남장례정보포털`,
        pageOgDescription: description,
        pageOgImage:
          regionParlors.length > 0
            ? regionParlors[0]?.images[0]?.url || ""
            : "",
      },
    };
  } else {
    const sidoName = code.split("(")[0];
    const sidoNumber = code.split("(")[1].replace(")", "");
    const regionParlors = parlors.filter((p) => p.sido === String(sidoNumber));

    const 가족장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["가족장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 무빈소장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["무빈소"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 일반장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["일반장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();

    let parlorsString = "";
    regionParlors.map((p: any) => {
      parlorsString += `${p.companyname} ${numberToLocalString(
        p.binsos[0].charge
      )}원, `;
    });

    const description = `${sidoName} 내 ${regionParlors.length}곳의 장례식장을 대상으로 한 비용 비교: 1일 동안 100명의 조문객이 참석할 때의 빈소 비용 및 추가 비용에 대한 정보 부산, 울산, 경남, 경상 및 주변 지역 장례식장 추천도 함께 포함 | ${parlorsString}...`;

    return {
      props: {
        regionParlors,
        expectedParlorPrice: { 무빈소장, 가족장, 일반장 },
        sidoName,
        sido: sidoNumber,
        isSigungu: false,
        pageDescription: description,
        pageKeywords: `${sidoName} 장례식장, ${sidoName} 장례식장 추천, ${sidoName} 장례식장 비용, ${sidoName} 장례식장 평균 예상 비용, ${sidoName} 무빈소, ${sidoName} 가족장, ${sidoName} `,
        pageOgTitle: `${sidoName} 지역 장례식장 추천, 비교 :: 부산울산경남장례정보포털`,
        pageOgDescription: description,
        pageOgImage:
          regionParlors.length > 0
            ? regionParlors[0]?.images[0]?.url || ""
            : "",
      },
    };
  }
};

export default function ParlorSlugTypePage({
  regionParlors,
  expectedParlorPrice,
  pageOgTitle,
  sido,
  sidoName,
  sigungu,
  sigunguName,
  isSigungu,
}: {
  regionParlors: Array<ParlorDetailProps>;
  expectedParlorPrice: { 무빈소장: number; 가족장: number; 일반장: number };
  pageOgTitle: string;
  sido: string;
  sidoName: string;
  sigungu?: string;
  sigunguName?: string;
  isSigungu: boolean;
}) {
  if (regionParlors.length === 0) {
    return <></>;
  }

  const parlorRegionPageSchema = buildParlorRegionPageSchema(regionParlors, {
    regionText: `${sidoName}${isSigungu && sigunguName ? ` ${sigunguName}` : ""}`,
    itemUrlBuilder: (id) =>
      `https://www.gyeongsang-portal.co.kr/funeral-companies/${id}/`,
  });

  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
      </Head>
      <RichSearch data={parlorRegionPageSchema} />

      <ParlorRegionHeadSection
        title={
          <BTypeRegionHead
            regionParlors={regionParlors}
            sidoName={sidoName}
            sigunguName={sigunguName}
            expectedParlorPrice={expectedParlorPrice}
            mainColor={regionColor}
            event={{
              domain: "gyeongsang",
              path: "prlr_recm",
              trigger_and_target: "uv_mth_req",
            }}
          />
        }
        ctaList={[]}
      />

      <CTypeParlorList
        sido={sido}
        sigungu={sigungu}
        title={`${sidoName} ${
          sigunguName ? " " + sigunguName : ""
        }의 다른 장례식장`}
        binsoAveragePrice={true}
        CardViewType={(res) => (
          <BTypeCardView
            descriptions={[
              `빈소 이용료: ${res.binsos[0].charge.toLocaleString()}원부터`,
            ]}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/funeral-companies/${res.id}/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "gyeongsang",
              path: "prlr_recm",
              trigger_and_target: "uv_prlr_detail",
            }}
          />
        )}
      />
      <Box padding="20px 0 " />
      {isSigungu && (
        <CTypeParlorList
          sido={sido}
          title={`${sidoName}의 다른 장례식장`}
          binsoAveragePrice={true}
          CardViewType={(res) => (
            <BTypeCardView
              descriptions={[
                `빈소 이용료: ${res.binsos[0].charge.toLocaleString()}원부터`,
              ]}
              mainColor={regionColor}
              key={res.companyname}
              name={res.companyname}
              href={`/funeral-companies/${res.id}/`}
              imgSrc={res.images[0] ? res.images[0].url : ""}
              event={{
                domain: "gyeongsang",
                path: "prlr_recm",
                trigger_and_target: "uv_prlr_detail",
              }}
            />
          )}
        />
      )}

      <ParlorRegionFAQ />
    </>
  );
}
